"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_paper_1 = require("react-native-paper");
const styles_1 = __importDefault(require("../../styles/styles"));
const boxTitle_1 = __importDefault(require("../boxTitle/boxTitle"));
const dialogStyles_1 = __importDefault(require("./dialogStyles"));
const Dialog = ({ title, text, action, visible, hideDialog }) => (react_1.default.createElement(react_native_paper_1.Portal, null,
    react_1.default.createElement(react_native_paper_1.Dialog, { visible: visible, onDismiss: hideDialog, style: [styles_1.default.whiteBackground, dialogStyles_1.default.modalView] },
        react_1.default.createElement(boxTitle_1.default, { title: title }),
        react_1.default.createElement(react_native_paper_1.Dialog.Content, null,
            react_1.default.createElement(react_native_paper_1.Paragraph, { style: styles_1.default.textColorBlack }, text)),
        react_1.default.createElement(react_native_paper_1.Dialog.Actions, null, action))));
exports.default = Dialog;
